export default __webpack_public_path__ + "static/media/yjsflix.f7b36053.png";